module.exports = __webpack_public_path__ + "static/media/MX.2b980f14.png";